import React from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';

export const stageName = (event) => {
    const name = event.st_event?.stage?.id ? event.st_event.stage.name : event.st_event.name;
    const description = event.st_event?.stage?.id ? event.st_event?.stage?.description : event.st_event?.description;

    return (
        <Popup
            trigger={<span>{name}</span>}
            position='top center'
            content={description}
            disabled={!description}
        />
    );
};

stageName.propTypes = {
    event: PropTypes.shape({
        st_event: PropTypes.shape({
            stage: PropTypes.shape({
                id: PropTypes.any,
                name: PropTypes.string,
            }),
            name: PropTypes.string,
            description: PropTypes.string,
        }),
    }),
};
